"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultShape = exports.defaultColor = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _createStyles = require("../styles/createStyles");
var _SwitchBase = _interopRequireDefault(require("../SwitchBase"));
var _capitalizeFirstWord = require("../utilities/capitalizeFirstWord");
var _CheckboxIcon = _interopRequireDefault(require("./CheckboxIcon"));
const _excluded = ["classes", "color", "shape", "outlined"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultColor = exports.defaultColor = 'primary';
const defaultShape = exports.defaultShape = 'circle';
const useStyles = (0, _createStyles.createStyles)(() => ({
  /* Styles applied to the checkbox's root element. */
  root: {},
  /* Styles applied to the top level root element. */
  checkbox: {
    '&[data-checked]': {
      "& [data-name='uncheckedIcon']": {
        display: 'none'
      },
      "& [data-name='checkedIcon']": {
        display: 'flex'
      }
    },
    "& [data-name='checkedIcon']": {
      display: 'none'
    }
  },
  /* Pseudo-class applied to the root element if `checked={true}`. */
  checked: {},
  /* Styles applied to the root element if `disabled={true}`. */
  disabled: {
    cursor: 'default'
  },
  /* Styles applied to the root element if `color="primary"`. */
  colorPrimary: {},
  /* Styles applied to the root element if `color="secondary"`. */
  colorSecondary: {},
  /* Styles applied to the root element if `shape="circle"`. */
  circle: {},
  /* Styles applied to the root element if `shape="square"`. */
  square: {}
}));
/**
 * **❗️ DEPRECATED**: Use the new `Checkbox` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/forms-checkbox):
 *
 * ```tsx
 * import { Checkbox } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/checkboxlabel)
 *
 * @deprecated
 */
const CheckboxBase = /*#__PURE__*/React.forwardRef(function CheckboxBase(props, ref) {
  const {
      classes: classesOverrides,
      color = defaultColor,
      shape = defaultShape,
      outlined
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  const iconProps = {
    color,
    shape,
    outlined
  };
  // We need to have both versions of the checkboxIcon in the DOM for server side generated pages
  const icon = /*#__PURE__*/React.createElement(_CheckboxIcon.default, (0, _extends2.default)({}, iconProps, {
    "data-name": "uncheckedIcon",
    "data-testid": "uncheckedIcon"
  }));
  const checkedIcon = /*#__PURE__*/React.createElement(_CheckboxIcon.default, (0, _extends2.default)({}, iconProps, {
    checked: true,
    "data-name": "checkedIcon",
    "data-testid": "checkedIcon"
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes.root, classes[shape]),
    ref: ref
  }, /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "checkbox",
    classes: {
      root: cx(classes.checkbox, classes[`color${(0, _capitalizeFirstWord.capitalizeFirstWord)(color)}`]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    icon: icon,
    checkedIcon: checkedIcon
  }, other)));
});
var _default = exports.default = CheckboxBase;